import { useLocation, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { vdomain } from "commons/config";
import { IoIosFunnel, IoIosArrowBack } from "react-icons/io";

import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { CgSpinnerTwo } from "react-icons/cg";


import style from "./style.module.scss";
import pgnStyle from "./pagination.module.scss";
import Item from "./Item";

var lastParams: Record<string, string> = {};
var lastLocationParams = "";

interface props {
    propertiesState: Record<string, any>;
    totalPagesState: Record<string, any>;
}
function SearchResults({ propertiesState, totalPagesState }: props) {

    const { properties, setProperties } = propertiesState;
    const { totalPages, setTotalPages } = totalPagesState;

    const location = useLocation();
    const history = useHistory();

    const [checked, setChecked] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageInputValue, setPageInputValue] = useState(1);

    const [imageCache, setImageCache] = useState({ result: {} });


    useEffect(() => {

        // console.log("CHECKING", lastLocationParams + " vs " +  location.search)
        if (lastLocationParams !== (location.search + "")) {
            var params = Object.fromEntries(new URLSearchParams(location.search));

            if (checkDataParamsChange(params)) {
                fetch(vdomain + "/int-search", { method: "POST", body: JSON.stringify({ ...params, getTotalPages: true }) }).then(async response => {
                    var result = await response.json();
                    setTotalPages(result.totalPages ? result.totalPages : 0);
                    lastParams = params;
                });
            }

            fetch(vdomain + "/int-search", { method: "POST", body: JSON.stringify(params) }).then(async response => {
                var result = await response.json();

                setChecked(true);
                setProperties(result);
            });

            var urlCurrentPage = (isNaN(Number(params.offset)) ? 1 : (Number(params.offset) + 1));
            if (currentPage !== urlCurrentPage) {
                setCurrentPage(urlCurrentPage);
                setPageInputValue(urlCurrentPage);
            }

            lastLocationParams = location.search;
        } else {
            setChecked(true);
        }

    //eslint-disable-next-line
    }, [location]);


    function checkDataParamsChange(params: Record<string, string>): boolean {
        var checkParams: string[] = ["ref", "type", "region", "location", "bedrooms", "from", "to"];

        var changed: boolean = false;
        checkParams.forEach((param: string) => (changed = changed || (params[param] !== lastParams[param])))

        return !!changed;
    }

    function changeQuery(params: Record<string, string>) {
        var currentParams = Object.fromEntries(new URLSearchParams(location.search));
        var newParams = { ...currentParams, ...params };

        var newpath = location.pathname;
        newpath += "?" + new URLSearchParams(newParams).toString();
        if ((window.location.href.length > newpath.length) && (window.location.href.substr(window.location.href.length - newpath.length) !== newpath)) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        history.push(newpath);
    }

    return (
        <div className={style.root}>

            <div className={style.topBarCnt}>

                <div className={style.topBar}>
                    <div className={style.backCnt} onClick={e => history.goBack()}>
                        <div className={style.backButton}><IoIosArrowBack />Back</div>
                    </div>

                    <div className={style.title}>Search results</div>

                    <div className={style.sortCnt}>
                        <div className={style.sortIconCnt}>
                            <IoIosFunnel size="20" className={style.sortIcon} />
                        </div>
                        <select className={style.formControls} onChange={e => {
                            changeQuery({ pricesort: e.target.value, offset: "0" });
                        }}>
                            <option value="ascending">
                                laag naar hoog
                            </option>
                            <option value="descending">
                                hoog naar laag
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            {
                (properties?.length < 1) && <div className={style.noResultCnt}>
                    <div className={style.noResult}>
                        {checked ? "No Result" : <CgSpinnerTwo size="60" className={style.spinAnim} />}
                    </div>
                </div>
            }

            <div className={style.center}>
                <div className={style.propertiesContainer}>
                    {properties?.map((item: Record<string, Record<string, any>>) => {
                        const key = Object.keys(item)[0];
                        return <Item data={item[key]} refNo={key} imageCache={{ images: imageCache, setImages: setImageCache }} key={key} />
                    })}
                </div>
            </div>


            {checked && (properties.length > 0) && <div className={pgnStyle.root}>
                <div className={pgnStyle.pgn_cnt}>

                    {(currentPage !== 1) && <div className={pgnStyle.pgn_arrows}>
                        <RiArrowLeftSLine size="40"
                            onClick={e => {
                                changeQuery({ offset: String(Math.max(currentPage - 1, 1) - 1) });
                            }}
                        />
                    </div>}

                    <input type="number" min="1" value={pageInputValue} onChange={e => {
                        var page = Number(e.target.value);
                        page = isNaN(page) ? 1 : page;
                        page = Math.min(page, totalPages);
                        if (page < 1) page = 1;
                        setPageInputValue(page);
                    }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                changeQuery({ offset: String(pageInputValue - 1) })
                            }
                        }}
                    />
                    <div>&nbsp;out of {totalPages}</div>

                    {(currentPage < totalPages) && <div className={pgnStyle.pgn_arrows}>
                        <RiArrowRightSLine size="40"
                            onClick={e => {
                                changeQuery({ offset: String(Math.min(currentPage + 1, totalPages) - 1) });
                            }}
                        />
                    </div>}

                </div>
            </div>}
        </div >
    );
}

export default SearchResults;